export const PAYMENT_NOT_VERIFIED_ERROR_CODE = 'lerror_72';
export const PROCESSING_FAILED_ERROR_CODE = 'lerror_73';
export const PAYMENT_FAILED_ERROR_CODE = 'lerror_75';

export const errorTexts = {
  [PAYMENT_NOT_VERIFIED_ERROR_CODE]: {
    title: 'paymentConfirmation.contractFailText',
    description: 'backendErrors.lerror_72',
  },
  [PROCESSING_FAILED_ERROR_CODE]: {
    title: 'paymentConfirmation.contractSuccessText',
    description: 'backendErrors.lerror_73',
  },
  [PAYMENT_FAILED_ERROR_CODE]: {
    title: 'paymentConfirmation.contractFailText',
    description: 'backendErrors.lerror_75',
  },
  default: {
    title: 'paymentConfirmation.contractFailText',
    description: 'backendErrors.lerror_72',
  },
};
